// =====================================================
// 📁 QuotationSelectedProducts.tsx
// =====================================================

import { useMemo, useState } from 'react';

import { useQuotation } from '../../../../../../hooks/sale/useQuotation';

import SearchField from '../../../../../Header/SearchInput/SearchField';

import QuotationEmptySelectedProducts from './QuotationEmptySelectedProducts';
import QuotationSelectedProductCard from './QuotationSelectedProductCard';

const QuotationSelectedProducts = () => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================

  const { form } = useQuotation();

  // =====================================================
  // 🔹 State
  // =====================================================

  const [search, setSearch] = useState('');

  // =====================================================
  // 🔹 Values
  // =====================================================

  const items = form?.items || [];

  // =====================================================
  // 🔹 Filters
  // =====================================================

  const filteredItems = useMemo(() => {
    const term = search.trim().toLowerCase();

    if (!term) return items;

    return items.filter((item) =>
      [item.productName]
        .filter(Boolean)
        .some((value) => String(value).toLowerCase().includes(term))
    );
  }, [items, search]);

  // =====================================================
  // 🔹 Empty
  // =====================================================

  if (items.length === 0) {
    return <QuotationEmptySelectedProducts />;
  }

  // =====================================================
  // 🎨 Render
  // =====================================================

  return (
    <div className="flex flex-col">
      <SearchField
        value={search}
        placeholder="Buscar producto cotizado..."
        onChange={setSearch}
      />

      {filteredItems.map((item) => (
        <QuotationSelectedProductCard key={item.id} item={item} />
      ))}
    </div>
  );
};

export default QuotationSelectedProducts;
